import { useEffect, useState } from "react";
import { useRouter } from "next/router";
import UpdatePaymentMethodModal from "./modals/update-payment-method";
import { useToast } from "../design";

function QuickAction() {
  const router = useRouter();
  const toasts = useToast();

  const [actionKey, setactionKey]: any = useState(null);
  const [actionModalActive, setactionModalActive] = useState(false);

  const toggleActiveDrawer = () => {
    setactionModalActive(!actionModalActive);
  }

  const displayActionMessage = (message: string, success: boolean) => {
    toasts.open({ message, time: 10000, type: success ? "success" : "failure" });
  }

  useEffect(() => {
    if (router.query.action) {
      setactionKey(router.query.action)
      setactionModalActive(true);
    }
  }, [router.isReady]);

  return (
    <>
      <UpdatePaymentMethodModal
        active={actionModalActive && actionKey == "update-pm"}
        toggleActive={toggleActiveDrawer}
        pmId={`gid://shopify/CustomerPaymentMethod/${router.query.pmId}`}
        displayActionMessage={displayActionMessage}
      />
    </>
  );
}

export default QuickAction;
